<template>
  <main id="explore-page" class="mainContainer container mt-5">
    <el-navbar />
    <div class="bg-white py-4"></div>
    <section v-if="data">
      <div class="tab-content container mt-4" id="myTabContent">
        <div id="info-tab-pane">
          <div class="container">
            <h3 class="text-capitalize text-primary">
              Hallo <strong>{{ data.firstname + " " + data.lastname }}</strong>!
            </h3>
            <h5>Username: <strong>@{{ data.username }}</strong></h5>
          </div>
          <hr />
          <nav class="">
            <router-link :to="{ name: 'CPanel' }" custom v-slot="{ navigate }">
              <span
                role="link"
                @click="navigate"
                class="btn me-2"
                @keypress.enter="navigate"
              >
                <i class="fa-solid fa-gamepad text-primary"></i>
                Armaturenbrett
              </span>
            </router-link>
            <router-link :to="{ name: 'Devices' }" custom v-slot="{ navigate }">
              <span
                role="link"
                @click="navigate"
                class="btn me-2"
                @keypress.enter="navigate"
              >
                <i class="fa-solid fa-mobile-screen-button text-primary"></i>
                Geräte
              </span>
            </router-link>
            <router-link :to="{ name: 'Services' }" custom v-slot="{ navigate }">
              <span
                role="link"
                @click="navigate"
                class="btn me-2"
                @keypress.enter="navigate"
              >
                <i class="fa-solid fa-bell-concierge text-primary"></i>
                Reparaturarten
              </span>
            </router-link>
            <router-link :to="{ name: 'Proceed' }" custom v-slot="{ navigate }">
              <span
                role="link"
                @click="navigate"
                class="btn me-2"
                @keypress.enter="navigate"
              >
                <i class="fa-solid fa-list-check text-primary"></i>
                Abwicklungen
              </span>
            </router-link>
            <router-link :to="{ name: 'Orders' }" custom v-slot="{ navigate }">
              <span
                role="link"
                @click="navigate"
                class="btn me-2"
                @keypress.enter="navigate"
              >
                <i class="fa-solid fa-cart-shopping text-primary"></i>
                Kundenbestellungen
              </span>
            </router-link>
            <router-link :to="{ name: 'Setting' }" custom v-slot="{ navigate }">
              <span
                role="link"
                @click="navigate"
                class="btn me-2"
                @keypress.enter="navigate"
              >
                <i class="fa-solid fa-gear text-primary"></i>
                Einstellungen
              </span>
            </router-link>
            <router-link :to="{ name: 'UpdatePassword' }" custom v-slot="{ navigate }">
              <span
                role="link"
                @click="navigate"
                class="btn me-2"
                @keypress.enter="navigate"
              >
                <i class="fa-solid fa-key text-primary"></i>
                Passwort aktualisieren
              </span>
            </router-link>
            <router-link :to="{ name: 'ServicePopup' }" custom v-slot="{ navigate }">
              <span
                role="link"
                @click="navigate"
                class="btn me-2"
                @keypress.enter="navigate"
              >
                <i class="fa-solid fa-truck-fast text-primary"></i>
                Aktuelles Angebot
              </span>
            </router-link>
          </nav>
        </div>
        <hr />
        <div v-if="$route.name == 'Orders'">
          <el-orders />
        </div>
        <div v-else-if="$route.name == 'Devices'">
          <el-devices />
        </div>
        <div v-else-if="$route.name == 'Services'">
          <el-services />
        </div>
        <div v-else-if="$route.name == 'Proceed'">
          <el-proceed />
        </div>
        <div v-else-if="$route.name == 'Setting'">
          <el-personal :user="data" />
        </div>
        <div v-else-if="$route.name == 'UpdatePassword'">
          <el-updatePassword :user="data" />
        </div>
        <div v-else-if="$route.name == 'ServiceEdit'">
          <el-ServiceEdit />
        </div>

        <div v-else-if="$route.name == 'ServicePopup'">
          <el-ServicePopup :user="data" />
        </div>
        <el-dashbaord v-else>Dashboard</el-dashbaord>
      </div>
    </section>
  </main>
</template>

<script>
import elNavbar from "../../components/Navbar.vue";
import elPersonal from "./components/settings/Personal.vue";
import elUpdatePassword from "./components/settings/UpdatePassword.vue";

import elServiceEdit from "./components/ServiceEdit.vue";
import elOrders from "./components/Orders.vue";
import elDevices from "./components/Devices.vue";
import elServices from "./components/Services.vue";
import elDashbaord from "./components/Dashbaord.vue";
import elProceed from "./components/Proceed.vue";
import elServicePopup from "./components/ServicePopup.vue";

export default {
  name: "CPanel",
  metaInfo() {
    return {
      title: "CPanel",
      titleTemplate: "%s | Mobile Tech Zone",
    };
  },

  components: {
    elNavbar,
    elPersonal,
    elUpdatePassword,
    elOrders,
    elDevices,
    elServices,
    elDashbaord,
    elProceed,
    elServiceEdit,
    elServicePopup
  },

  data() {
    return {
      currentPost: undefined,

      setting: undefined,
      data: undefined,
      posts: undefined,
      media: undefined,
      list: undefined,
      oldData: {},
      followState: undefined,
      filter: "updated_at",
      lastindexPost: 0,
      currentPage: 1,
      perPage: 5,
      total: 0,
    };
  },

  watch: {
    "$store.state.utils.updatingScroll"(top) {
      if (!this.$refs.listPosts) return;
      const scrollIn = window.innerHeight + top;

      if (
        scrollIn > this.$refs.listPosts.clientHeight &&
        this.total > this.currentPage &&
        !this.$store.state.utils.spiner
      ) {
        this.currentPage++;
        this.lastindexPost = this.lastindexPost + this.perPage;
        this.$store.state.utils.spiner = true;
        this.loadUnits();
      }
    },
  },

  mounted() {
    this.$nextTick(() => {
      if (localStorage.account) {
        this.switshLoadData();
      } else {
        this.$router.push({ name: "LandingPage" });
      }
    });
  },

  methods: {
    switshLoadData() {
      this.$store.state.updatingPostsObject = [];

      this.loadVisitProfile(this.$store.state.modules.account.user.username);
      this.oldData = JSON.parse(
        JSON.stringify(this.$store.state.modules.account.user)
      );

      this.$store.state.utils.loaded = true;
    },

    loadVisitProfile(username) {
      console.log(username);
      this.$store.state.modules.api
        .getUserByUsername(JSON.parse(localStorage.account).token, username)
        .then((resp) => {
          console.log(resp.data);
          if (resp.status == 200) {
            this.data = resp.data.result;
            // this.loadUnits();
            if (this.data.maincolor) {
              document.documentElement.style.setProperty(
                "--bs-primary-rgb",
                this.$store.state.utils.filters.hexToRgb(this.data.maincolor)
              );
            }

            this.$store.state.utils.loaded = true;
          } else {
            this.$router.push({ name: "NotFound" });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },

    loadUnits() {
      this.$store.state.modules.api
        .loadMyPosts(
          this.lastindexPost,
          this.perPage,
          this.filter,
          this.data.accountId,
          JSON.parse(localStorage.account).token
        )
        .then((resp) => {
          console.log(resp);
          if (resp.status == 200) {
            if (!this.$store.state.updatingPostsObject) {
              this.$store.state.updatingPostsObject = [];
            }

            this.$store.state.updatingPostsObject.push(...resp.data.units);
            this.total = resp.data.total;
          } else {
            this.$store.state.updatingPostsObject = [];
          }
          this.$store.state.utils.loaded = true;
          this.$store.state.utils.spiner = false;
        })
        .catch((err) => {
          console.error(err);
        });
    },

    followToggle() {
      this.$store.state.modules.api
        .followToggle(
          this.data.accountId,
          JSON.parse(localStorage.account).token
        )
        .then((resp) => {
          if (resp.status == 200) {
            // this.data.is_followed = resp.data.unit.y;
            console.log(resp.data.unit.y);
            // if (resp.data.unit.x) {
            //   this.user.followers++;
            // } else {
            //   this.user.followers--;
            // }
          } else {
            // TODO: Error
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
  },
};
</script>
